import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import ReactQuill from "react-quill";

const toolbarOptions = [
  [{ header: [1, 2, false] }],
  ["bold", "italic", "underline"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ align: [] }],
  ["clean"],
];

const modules = {
  toolbar: toolbarOptions,
};

const ViewComment = (props) => {
  const { openViewNote, handleCloseViewNote, content, setContent } = props;

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth="sm"
      open={openViewNote}
    >
      <MuiDialogTitle
        disableTypography
        style={{ color: "#4f2d7f", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Typography variant="h6">{'Comment'}</Typography>
          <CloseIcon
            onClick={handleCloseViewNote}
            style={{ cursor: "pointer" }}
          />
        </div>
      </MuiDialogTitle>
      <MuiDialogContent
        dividers
        // style={{ padding: "10px", height: "15em", overflowY: "scroll" }}
      >
        <ReactQuill
          value={content}
          onChange={setContent}
          theme="snow"
          modules={modules}
          placeholder="Write your comment here..."
          readOnly={true}
        />
      </MuiDialogContent>
    </Dialog>
  );
};

export default ViewComment;
